<form [formGroup]="form">
  <p-card header="Trailer Summary">
    <div class="p-grid">
      <div class="form-group p-col-3">
        <label class="required" for="trailersAtReturnCenter">Trailers at Return Center</label>
        <input type="number" pInputText class="form-control chepInput" id="trailersAtReturnCenter" name="trailersAtReturnCenter"
          formControlName="trailersAtReturnCenter" lib-numeric>
        <error-block [field]="form.controls.trailersAtReturnCenter" [messages]="{
          required: 'Trailers at Return Center is required.',
          numeric: 'Trailers at Return Center must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-3">
        <label class="required" for="trailersAtUac">Trailers at UAC</label>
        <input type="number" pInputText class="form-control chepInput" id="trailersAtUac" name="trailersAtUac"
          formControlName="trailersAtUac" lib-numeric>
        <error-block [field]="form.controls.trailersAtUac" [messages]="{
          required: 'Trailers at UAC is required.',
          numeric: 'Trailers at UAC must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-3">
        <label class="required" for="trailersAtDrop">Trailers Offsite</label>
        <input type="number" pInputText class="form-control chepInput" id="trailersAtDrop" name="trailersAtDrop"
          formControlName="trailersAtDrop" lib-numeric>
        <error-block [field]="form.controls.trailersAtDrop" [messages]="{
          required: 'Trailers at Drop is required.',
          numeric: 'Trailers at Drop must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-3">
        <label class="required" for="emptyTrailers">Empty Trailers</label>
        <input type="number" pInputText class="form-control chepInput" id="emptyTrailers" name="emptyTrailers"
          formControlName="emptyTrailers" lib-numeric>
        <error-block [field]="form.controls.emptyTrailers" [messages]="{
          required: 'Empty Trailers is required.',
          numeric: 'Empty Trailers must be a number.'
        }"></error-block>
      </div>
    </div>
  </p-card>

  <p-card header="Pallet Position Summary">
    <div class="p-grid">
      <div class="form-group p-col-4">
        <label class="required" for="unlottedPallets">Unlotted Pallets</label>
        <input type="number" pInputText class="form-control chepInput" id="unlottedPallets" name="unlottedPallets"
          formControlName="unlottedPallets" lib-numeric>
        <error-block [field]="form.controls.unlottedPallets" [messages]="{
          required: 'Unlotted Pallets is required.',
          numeric: 'Unlotted Pallets must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="itCagePallets">IT Cage Pallets</label>
        <input type="number" pInputText class="form-control chepInput" id="itCagePallets" name="itCagePallets"
          formControlName="itCagePallets" lib-numeric>
        <error-block [field]="form.controls.itCagePallets" [messages]="{
          required: 'IT Cage Pallets is required.',
          numeric: 'IT Cage Pallets must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="itemResearchPallets">Item Research Pallets</label>
        <input type="number" pInputText class="form-control chepInput" id="itemResearchPallets" name="itemResearchPallets"
          formControlName="itemResearchPallets" lib-numeric>
        <error-block [field]="form.controls.itemResearchPallets" [messages]="{
          required: 'Item Research Pallets is required.',
          numeric: 'Item Research Pallets must be a number.'
        }"></error-block>
      </div>
    </div>
  </p-card>

  <p-card header="Comments">
    <div class="p-grid">
      <div class="form-group p-col">
        <textarea pInputTextarea class="form-control textarea" formControlName="comments" style="width: 100%"></textarea>
      </div>
    </div>
  </p-card>

  <p-card header="Current Day Production">
    <div class="p-grid">
      <div class="form-group p-col-4">
        <label class="required" for="dropsUnloaded">Drops Unloaded</label>
        <input type="number" pInputText class="form-control chepInput" id="dropsUnloaded" name="dropsUnloaded"
          formControlName="dropsUnloaded" lib-numeric>
        <error-block [field]="form.controls.dropsUnloaded" [messages]="{
          required: 'Drops Unloaded is required.',
          numeric: 'Drops Unloaded must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="liveLoadsUnloaded">Live Loads Unloaded</label>
        <input type="number" pInputText class="form-control chepInput" id="liveLoadsUnloaded" name="liveLoadsUnloaded"
          formControlName="liveLoadsUnloaded" lib-numeric>
        <error-block [field]="form.controls.liveLoadsUnloaded" [messages]="{
          required: 'Live Loads Unloaded is required.',
          numeric: 'Live Loads Unloaded must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="palletPositionsOffloaded">Pallet Positions Offloaded</label>
        <input type="number" pInputText class="form-control chepInput" id="palletPositionsOffloaded" name="palletPositionsOffloaded"
          formControlName="palletPositionsOffloaded" lib-numeric>
        <error-block [field]="form.controls.palletPositionsOffloaded" [messages]="{
          required: 'Pallet Positions Offloaded is required.',
          numeric: 'Pallet Positions Offloaded must be a number.'
        }"></error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-4">
        <label class="required" for="outboundsShipped">Outbounds Shipped</label>
        <input type="number" pInputText class="form-control chepInput" id="outboundsShipped" name="outboundsShipped"
          formControlName="outboundsShipped" lib-numeric>
        <error-block [field]="form.controls.outboundsShipped" [messages]="{
          required: 'Outbounds Shipped is required.',
          numeric: 'Outbounds Shipped must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="propakScrapTrailerOutbounds">Propak Scrap Trailer Outbounds</label>
        <input type="number" pInputText class="form-control chepInput" id="propakScrapTrailerOutbounds" name="propakScrapTrailerOutbounds"
          formControlName="propakScrapTrailerOutbounds" lib-numeric>
        <error-block [field]="form.controls.propakScrapTrailerOutbounds" [messages]="{
          required: 'Propak Scrap Trailer Outbounds is required.',
          numeric: 'Propak Scrap Trailer Outbounds must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="otherScrapTrailerOutbounds">Other Scrap Trailer Outbounds</label>
        <input type="number" pInputText class="form-control chepInput" id="otherScrapTrailerOutbounds" name="otherScrapTrailerOutbounds"
          formControlName="otherScrapTrailerOutbounds" lib-numeric>
        <error-block [field]="form.controls.otherScrapTrailerOutbounds" [messages]="{
          required: 'Other Scrap Trailer Outbounds is required.',
          numeric: 'Other Scrap Trailer Outbounds must be a number.'
        }"></error-block>
      </div>
    </div>
    <div class="p-grid">
      <div class="form-group p-col-4">
        <label class="required" for="scrapPreCrusherOutbounds">Scrap Pre-Crusher Outbounds</label>
        <input type="number" pInputText class="form-control chepInput" id="scrapPreCrusherOutbounds" name="scrapPreCrusherOutbounds"
          formControlName="scrapPreCrusherOutbounds" lib-numeric>
        <error-block [field]="form.controls.scrapPreCrusherOutbounds" [messages]="{
          required: 'Scrap Pre-Crusher Outbounds is required.',
          numeric: 'Scrap Pre-Crusher Outbounds must be a number.'
        }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="trashOutbounds">Trash Outbounds</label>
        <input type="number" pInputText class="form-control chepInput" id="trashOutbounds" name="trashOutbounds"
               formControlName="trashOutbounds" lib-numeric>
        <error-block [field]="form.controls.trashOutbounds" [messages]="{
        required: 'Trash Outbounds is required.',
        numeric: 'Trash Outbounds must be a number.'
      }"></error-block>
      </div>
      <div class="form-group p-col-4">
        <label class="required" for="trashCompactorOutbounds">Trash Compactor Outbounds</label>
        <input type="number" pInputText class="form-control chepInput" id="trashCompactorOutbounds" name="trashCompactorOutbounds"
               formControlName="trashCompactorOutbounds" lib-numeric>
        <error-block [field]="form.controls.trashCompactorOutbounds" [messages]="{
        required: '>Trash Compactor Outbounds is required.',
        numeric: '>Trash Compactor Outbounds must be a number.'
      }"></error-block>
      </div>
    </div>

  </p-card>

  <p-card header="Run Production">
    <p-table [value]="handlingItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Production Type<span class="required">*</span></th>
          <th>Total<span class="required">*</span></th>
          <th>Delete</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
        <tr [formGroup]="rowData">
          <td>
            <p-dropdown [options]="handlingTypes" formControlName="productId" appendTo="body" name="rpcType"
                        [required] [filter]="true" [editable]="false" [resetFilterOnHide]="true">
            </p-dropdown>
          </td>
          <td>
            <input pInputText type="number" formControlName="handledS1" style="width:100%" name="rpcSortedShift1"
                required>
          </td>
          <td>
            <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
                                confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle" cancelText="Cancel"
                                (actionConfirmed)="deleteHandling(rowData)" [disabled]="handlingAddForm.disabled">
            </confirmation-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="7" class="centered">
            No data available
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer" let-rowData>
        <tr [formGroup]="handlingAddForm">
          <td>
            <p-dropdown [options]="handlingTypes" [required] appendTo="body" placeholder="-- Select Production Type --" inputId="handlingType"
                        class="form-control" name="handlingType" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="productId">
            </p-dropdown>
            <error-block [field]="handlingAddForm.controls.productId" [messages]="{
              required: 'Production Type is required.'
            }">
            </error-block>
          </td>
          <td class="shift1">
            <input type="number" lib-numeric pInputText id="handlingShift1" required name="handlingShift1" class="form-control" formControlName="handledS1"/>
            <error-block [field]="handlingAddForm.controls.handledS1" [messages]="{
              required: 'Count is required.'
            }">
            </error-block>
          </td>
          <td>
            <button type="button" pButton icon="pi pi-plus" iconPos="left" (click)="addHandling();" label="Add" [ngClass]="{ 'p-state-disabled': !handlingAddForm.valid }" [disabled]="handlingAddForm.disabled"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</form>
